import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { ToastrService } from 'ngx-toastr';
import { ParaderoListItemDTO } from '../../../dtos/response/getListaParaderos.response.dto';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { GetListaServiciosResponseDTO } from '../../../dtos/response/getListaServicios.response.dto';
import { NgSelectModule } from '@ng-select/ng-select';
import { ServicioDTO } from '../../../dtos/servicio.dto';
import { EventService } from '../../services/event.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
import { SucursalDTO } from '../../../dtos/sucursal.dto';
import { GetListaSucursalesResponseDTO } from '../../../dtos/response/getListaSucursales.response.dto';
import { ViajeEspecial } from '../../../dtos/viajeEspecial.dto';
import { GetListaViajesEspecialesResponseDTO } from '../../../dtos/response/getListaViajesEspeciale.response.dto';
import { UserService } from '../../services/user.service';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-modal-crear-viaje',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, BsDatepickerModule],
  templateUrl: './modal-crear-viaje-v2.component.html',
  styleUrl: './modal-crear-viaje-v2.component.scss'
})
export class ModalCrearViajeV2Component implements OnInit {
  // Trip type
  tripTypes = {
    COMERCIAL: 'VIAJE COMERCIAL',
    NO_COMERCIAL: 'VIAJE NO COMERCIAL',
    ESPECIAL: 'VIAJE ESPECIAL'
  };
  selectedTripType: string = this.tripTypes.ESPECIAL;

  // Paraderos data
  listaParaderos: ParaderoListItemDTO[] = [];
  paraderoOrigenSeleccionado: ParaderoListItemDTO;
  textoParaderoOrigen: string;
  paraderoDestinoSeleccionado: ParaderoListItemDTO;
  textoParaderoDestino: string;
  filteredParaderos: ParaderoListItemDTO[] = [];
  loading = false;

  nombreViajeEspecial: string;
  descripcion: string;

  nombreViajeNoComercial: string;
  descripcionViajeNoComercial: string;

  public listaViajes : ViajeEspecial[] = [];
  public viajeEspecialSeleccionado : ViajeEspecial;

  // Servicios data
  public listaServicios : ServicioDTO[] = [];
  public servicioSeleccionado : ServicioDTO;

  // Terminales data
  public listaSucursales: Array<SucursalDTO> = [];
  terminalDestinoSeleccionado : SucursalDTO;
  terminalOrigenSeleccionado : SucursalDTO;

  // Selected values
  origenUuid: string = '';
  destinoUuid: string = '';

  // Search text
  searchText: string = '';
  private searchTextChanged = new Subject<string>();

  // Form data
  fechaInicio: string = new Date().toISOString().split('T')[0];
  fechaTermino: string = new Date().toISOString().split('T')[0]; // Current date in YYYY-MM-DD format
  horaInicio: string = '08:00';
  horaTermino: string = '10:00';
  sentido: string = 'IDA'; // Default direction

  // Direction options
  direcciones = ['IDA', 'VUELTA'];

  enviando: boolean = false;

  // Limite inferior de los calendarios de inicio: no se permiten fechas pasadas
  public hoy: Date = new Date();

  public fechas: { [key: string]: Date } = this.fechasIniciales();

  public horas: { [key: string]: string } = this.horasIniciales();

  private fechasIniciales(): { [key: string]: Date } {
    return {
      fechaSalidaTerminalViajeComercial: new Date(),
      fechaInicioViajeComercial: new Date(),
      fechaTerminoViajeComercial: new Date(),
      fechaLlegadaTerminalViajeComercial: new Date(),

      fechaInicioViajeNoComercial: new Date(),
      fechaTerminoViajeNoComercial: new Date(),

      fechaInicioViajeEspecial: new Date(),
      fechaTerminoViajeEspecial: new Date(),
    };
  }

  private horasIniciales(): { [key: string]: string } {
    return {
      horaSalidaTerminalViajeComercial: moment().format('HH:mm'),
      horaInicioViajeComercial: moment().format('HH:mm'),
      horaTerminoViajeComercial: moment().format('HH:mm'),
      horaLlegadaTerminalViajeComercial: moment().format('HH:mm'),

      horaInicioViajeNoComercial: moment().format('HH:mm'),
      horaTerminoViajeNoComercial: moment().format('HH:mm'),

      horaInicioViajeEspecial: moment().format('HH:mm'),
      horaTerminoViajeEspecial: moment().format('HH:mm'),
    };
  }

  constructor(
    private apiService: ApiService,
    private eventService: EventService,
    private modalRef: BsModalRef,
    private toastr: ToastrService,
    private userService: UserService,
  ) {
    // Setup search debounce
    this.searchTextChanged.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(text => {
      this.searchParaderos(text);
    });
  }

  ngOnInit(): void {
    this.seleccionarTipoViajeSegunPermisos();

    // Load initial paraderos
    this.getListaViajesEspeciales();
    this.getListaParaderos();
    this.getListaServicios();
    this.getListaSucursales();
  }

  private seleccionarTipoViajeSegunPermisos(): void {
    if (this.tienePermisoCrearViajeEspecial()) {
      this.selectedTripType = this.tripTypes.ESPECIAL;
    } else if (this.tienePermisoCrearViajeComercial()) {
      this.selectedTripType = this.tripTypes.COMERCIAL;
    } else if (this.tienePermisoCrearViajeNoComercial()) {
      this.selectedTripType = this.tripTypes.NO_COMERCIAL;
    }
  }

  getListaViajesEspeciales() {
    
    this.apiService.getListaViajesEspecialesDespachador().
    subscribe(
      (resp) => this.getListaViajesEspecialesSuccess(resp), 
      (error) => this.getListaViajesEspecialesError(error)
    );
  }

  getListaViajesEspecialesSuccess(getListaViajesEspecialesResponseDTO : GetListaViajesEspecialesResponseDTO){
    this.listaViajes = getListaViajesEspecialesResponseDTO.data;
  }

  getListaViajesEspecialesError(error: HttpErrorResponse) {
    console.log('error lista viajes especiales', error);
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  actualizarCamposDesdeViaje(viajeEspecial: ViajeEspecial){
    this.nombreViajeEspecial = viajeEspecial.nombre;
    this.textoParaderoOrigen = viajeEspecial.textoLibreOrigen;
    this.textoParaderoDestino = viajeEspecial.textoLibreDestino;
    this.descripcion = viajeEspecial.descripcion;

    //sucursales
    this.terminalOrigenSeleccionado = this.listaSucursales.find(sucursal => sucursal.uuid === viajeEspecial.sucursalOrigenUuid);
    this.terminalDestinoSeleccionado = this.listaSucursales.find(sucursal => sucursal.uuid === viajeEspecial.sucursalDestinoUuid);
    
  }

  getListaServicios() {
    
    this.apiService.getListaServicios().
    subscribe((resp) => this.getListaServiciosSuccess(resp), (error) => this.getListaServicioError(error));

  }

  getListaServiciosSuccess(getListaServiciosResponseDTO : GetListaServiciosResponseDTO){
    this.listaServicios = getListaServiciosResponseDTO.data.list;
  }

  getListaServicioError(error: HttpErrorResponse) {
    console.log('error lista servicios', error);
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  getListaSucursales() {
    this.apiService.getListaSucursales().subscribe((resp) => this.getListaSucursalesSuccess(resp), (error) => this.getListaSucursalesError(error));
  }

  getListaSucursalesSuccess(getListaSucursalesResponseDTO: GetListaSucursalesResponseDTO) {
    console.log('exito get sucursales', getListaSucursalesResponseDTO);
    this.listaSucursales = getListaSucursalesResponseDTO.data;
  }

  getListaSucursalesError(error: HttpErrorResponse) {
    console.log('error get sucursales', error);
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  // Load paraderos from API
  getListaParaderos(textoLibre: string = ''): void {
    this.loading = true;
    this.apiService.getListaParaderos(0, 1_000_000, textoLibre).subscribe({
      next: (response) => {
        this.getListaParaderosSuccess(response)
      },
      error: (error) => {
        this.getListaParaderosError(error)
      }
    });
  }

  getListaParaderosSuccess(getListaParaderosDTO){
    this.listaParaderos = getListaParaderosDTO.data.list;
    this.filteredParaderos = [...this.listaParaderos];
    this.loading = false;
  }

  getListaParaderosError(error: HttpErrorResponse) {
    console.log('error lista servicios', error);
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
    this.loading = false;
  }

  // Handle search input changes
  onSearchChange(text: string): void {
    this.searchTextChanged.next(text);
  }

  // Search paraderos with API
  searchParaderos(text: string): void {
    if (text.length > 2) {
      this.getListaParaderos(text);
    } else if (text.length === 0) {
      this.getListaParaderos();
    }
  }

  // Handle origin selection
  onOrigenChange(uuid: string): void {
    this.origenUuid = uuid;
    // Prevent selecting the same paradero for both origin and destination
    if (this.destinoUuid === uuid) {
      this.destinoUuid = '';
    }
  }

  // Handle destination selection
  onDestinoChange(uuid: string): void {
    this.destinoUuid = uuid;
    // Prevent selecting the same paradero for both origin and destination
    if (this.origenUuid === uuid) {
      this.origenUuid = '';
    }
  }

  // Get paradero name by UUID
  getParaderoName(uuid: string): string {
    const paradero = this.listaParaderos.find(p => p.uuid === uuid);
    return paradero ? `${paradero.nombre} (${paradero.visibleId})` : '';
  }

  // Handle trip type change
  onTripTypeChange(tripType: string): void {
    this.selectedTripType = tripType;
    this.limpiarFormularios();
  }

  // Deja todos los formularios en su estado inicial al cambiar el tipo de servicio
  private limpiarFormularios(): void {
    this.servicioSeleccionado = null;
    this.viajeEspecialSeleccionado = null;
    this.nombreViajeEspecial = null;
    this.descripcion = null;
    this.nombreViajeNoComercial = null;
    this.descripcionViajeNoComercial = null;
    this.textoParaderoOrigen = null;
    this.textoParaderoDestino = null;
    this.terminalOrigenSeleccionado = null;
    this.terminalDestinoSeleccionado = null;
    this.fechas = this.fechasIniciales();
    this.horas = this.horasIniciales();
  }

  // Check if a trip type is selected
  isTripTypeSelected(tripType: string): boolean {
    return this.selectedTripType === tripType;
  }

  // Si la fecha de inicio queda despues de la de termino, el termino pasa a ser la fecha de inicio
  ajustarFechaTermino(fechaInicio: Date, terminoKey: string): void {
    const termino = this.fechas[terminoKey];
    if (fechaInicio && termino && moment(fechaInicio).isAfter(termino, 'day')) {
      this.fechas[terminoKey] = new Date(fechaInicio);
    }
  }

  private avisar(mensaje: string): void {
    this.toastr.warning(mensaje, 'Aviso', { timeOut: environment.toastWarningTimeout, extendedTimeOut: environment.toastWarningTimeout, closeButton: true, tapToDismiss: false });
  }

  private fechaHora(fecha: Date, hora: string): moment.Moment {
    if (!fecha) return moment.invalid();
    return moment(moment(fecha).format('YYYY-MM-DD') + ' ' + hora, 'YYYY-MM-DD HH:mm', true);
  }

  // Valida fechas obligatorias, no pasadas y con inicio < termino. Devuelve true si es valido.
  private validarFechas(inicio: moment.Moment, termino: moment.Moment, fechaComparadaConAhora: moment.Moment = inicio): boolean {
    if (!inicio.isValid() || !termino.isValid() || !fechaComparadaConAhora.isValid()) {
      this.avisar('Debe ingresar fechas y horas validas');
      return false;
    }
    const ahora = moment().startOf('minute');
    if (fechaComparadaConAhora.isBefore(ahora) || termino.isBefore(ahora)) {
      this.avisar('No se puede crear un viaje en el pasado');
      return false;
    }
    if (inicio.isSameOrAfter(termino)) {
      this.avisar('La fecha y hora de inicio deben ser anteriores a las de termino');
      return false;
    }
    return true;
  }

  private validarOrigenDestino(): boolean {
    const tieneOrigen = !!this.terminalOrigenSeleccionado || !!this.textoParaderoOrigen?.trim();
    const tieneDestino = !!this.terminalDestinoSeleccionado || !!this.textoParaderoDestino?.trim();
    if (!tieneOrigen || !tieneDestino) {
      this.avisar('Debe indicar origen y destino');
      return false;
    }
    return true;
  }

  crearViajeNoComercial(): void{

    if (!this.validarOrigenDestino()) return;
    if (!this.validarFechas(
      this.fechaHora(this.fechas['fechaInicioViajeNoComercial'], this.horas['horaInicioViajeNoComercial']),
      this.fechaHora(this.fechas['fechaTerminoViajeNoComercial'], this.horas['horaTerminoViajeNoComercial']))) return;

    this.enviando = true;

    const fechaHoraInicioViajeNoComercial = this.fechaHora(this.fechas['fechaInicioViajeNoComercial'], this.horas['horaInicioViajeNoComercial']).format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraTerminoViajeNoComercial = this.fechaHora(this.fechas['fechaTerminoViajeNoComercial'], this.horas['horaTerminoViajeNoComercial']).format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraInicio = moment(this.fechaInicio + " " +this.horaInicio, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraTermino = moment(this.fechaTermino + " " +this.horaTermino, 'YYYY-MM-DD HH:mm').format('YYYY-MM-DDTHH:mm:ss');
    const sucursalOrigenUuid = this.terminalOrigenSeleccionado?.uuid
    const sucursalDestinoUuid = this.terminalDestinoSeleccionado?.uuid

    this.apiService.postCrearViajeNoComercialDespachador(
      this.descripcionViajeNoComercial,
      this.textoParaderoOrigen,
      sucursalOrigenUuid,
      fechaHoraInicioViajeNoComercial,
      this.textoParaderoDestino,
      sucursalDestinoUuid,
      fechaHoraTerminoViajeNoComercial
    ).subscribe(
      (resp) => this.crearViajeNoComercialSuccess(resp),
      (error) => this.crearViajeNoComercialError(error) 
    );
  }

  crearViajeNoComercialSuccess(res: any){
    console.log({ res })
    this.eventService.publish('CREAR_VIAJE_EVENT');
    this.close();
  }

  crearViajeNoComercialError(error :HttpErrorResponse){
    this.enviando = false;
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  crearViajeEspecial(): void{

    if (!this.validarOrigenDestino()) return;
    if (!this.validarFechas(
      this.fechaHora(this.fechas['fechaInicioViajeEspecial'], this.horas['horaInicioViajeEspecial']),
      this.fechaHora(this.fechas['fechaTerminoViajeEspecial'], this.horas['horaTerminoViajeEspecial']))) return;

    this.enviando = true;

    const fechaHoraInicioViajeEspecial = this.fechaHora(this.fechas['fechaInicioViajeEspecial'], this.horas['horaInicioViajeEspecial']).format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraTerminoViajeEspecial = this.fechaHora(this.fechas['fechaTerminoViajeEspecial'], this.horas['horaTerminoViajeEspecial']).format('YYYY-MM-DDTHH:mm:ss');
    const sucursalOrigenUuid = this.terminalOrigenSeleccionado?.uuid
    const sucursalDestinoUuid = this.terminalDestinoSeleccionado?.uuid

    this.apiService.postCrearViajeEspecialDespachador(
      this.nombreViajeEspecial, this.descripcion,
      this.textoParaderoOrigen, sucursalOrigenUuid, fechaHoraInicioViajeEspecial,
      this.textoParaderoDestino, sucursalDestinoUuid, fechaHoraTerminoViajeEspecial)
      .subscribe({
        next: (res) => this.crearViajeEspecialSuccess(res),
        error: (err) => this.crearViajeEspecialError(err)
      })
  }

  crearViajeEspecialSuccess(res){
    console.log({ res })
    this.enviando = false;
    this.eventService.publish('CREAR_VIAJE_EVENT');
    this.close();
  }

  crearViajeEspecialError(error: HttpErrorResponse){
    this.enviando = false;
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  tienePermisoCrearViajeComercial(): boolean {
    return this.userService.tienePermiso('VIAJE_CREAR_COMERCIAL');
  }

  tienePermisoCrearViajeNoComercial(): boolean {
    return this.userService.tienePermiso('VIAJE_CREAR_NO_COMERCIAL');
  }

  tienePermisoCrearViajeEspecial(): boolean {
    return this.userService.tienePermiso('VIAJE_CREAR_ESPECIAL');
  }

  crearViajeComercial(): void {

    if(!this.servicioSeleccionado){
      this.avisar("Debe seleccionar un servicio");
      return;
    }
    const esTerminal = (uuid: string) => this.listaSucursales.some(sucursal => sucursal.uuid === uuid);
    if (!esTerminal(this.servicioSeleccionado.sucursalOrigenUuid) || !esTerminal(this.servicioSeleccionado.sucursalDestinoUuid)) {
      this.avisar('El origen y el destino del servicio deben corresponder a un terminal');
      return;
    }
    if (!this.validarFechas(
      this.fechaHora(this.fechas['fechaInicioViajeComercial'], this.horas['horaInicioViajeComercial']),
      this.fechaHora(this.fechas['fechaTerminoViajeComercial'], this.horas['horaTerminoViajeComercial']),
      this.fechaHora(this.fechas['fechaSalidaTerminalViajeComercial'], this.horas['horaSalidaTerminalViajeComercial']))) return;

    this.enviando = true;

    const fechaHoraSalidaTerminalViajeComercial = this.fechaHora(this.fechas['fechaSalidaTerminalViajeComercial'], this.horas['horaSalidaTerminalViajeComercial']).format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraInicioViajeViajeComercial = this.fechaHora(this.fechas['fechaInicioViajeComercial'], this.horas['horaInicioViajeComercial']).format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraTerminoViajeViajeComercial = this.fechaHora(this.fechas['fechaTerminoViajeComercial'], this.horas['horaTerminoViajeComercial']).format('YYYY-MM-DDTHH:mm:ss');
    const fechaHoraLlegadaTerminalViajeComercial = this.fechaHora(this.fechas['fechaLlegadaTerminalViajeComercial'], this.horas['horaLlegadaTerminalViajeComercial']).format('YYYY-MM-DDTHH:mm:ss');
    
    const codigoServicio = this.servicioSeleccionado.codigoServicio;

    this.apiService.postCrearViajeDespachador(codigoServicio, 
      fechaHoraSalidaTerminalViajeComercial,
      fechaHoraInicioViajeViajeComercial,
      fechaHoraTerminoViajeViajeComercial,
      fechaHoraLlegadaTerminalViajeComercial).subscribe({
      next: (res) => this.crearViajeComercialSuccess(res),
      error: (err) => this.crearViajeComercialError(err)
    })
  }

  crearViajeComercialSuccess(res: any){
    console.log({ res })
    this.enviando = false;
    this.eventService.publish('CREAR_VIAJE_EVENT');
    this.close();
  }

  crearViajeComercialError(error: HttpErrorResponse){
    this.enviando = false;
    console.log('error lista viajes', error);
    this.toastr.error((error.error?.msg || '') + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  close() {
    this.modalRef.hide();
  }

  get paraderoDestinoSeleccionadoEsTerminal(){
    return this.paraderoDestinoSeleccionado && this.paraderoDestinoSeleccionado.terminal == true;
  }

  get paraderoOrigenSeleccionadoEsTerminal(){
    return this.paraderoOrigenSeleccionado && this.paraderoOrigenSeleccionado.terminal == true;
  }

  // Close the modal
  cerrarModal(): void {
    this.modalRef.hide();
  }

  formatearTiempo(event: any, campo: string) {
    const input = event.target;
    let value = input.value;
    const isBackspace = event.inputType === 'deleteContentBackward';
  
    value = value.replace(/[^0-9]/g, '');
    if (value.length > 4) value = value.slice(0, 4);
    if (value.length >= 3) {
      value = value.slice(0, 2) + ':' + value.slice(2);
    } else if (value.length >= 2 && !isBackspace) {
      value = value.slice(0, 2) + ':';
    }
  
    input.value = value;
    if (!isBackspace && value.length === 3 && value.includes(':')) {
      input.setSelectionRange(3, 3);
    }
  
    this.horas[campo] = value;
  }

  normalizarCampoHora(campo: string) {
    this.horas[campo] = this.normalizarHora(this.horas[campo]);
  }
  
  normalizarHora(hora: string): string {
    let value = hora.replace(/[^0-9]/g, '');
  
    if (value.length === 1) return `0${value}:00`;
    if (value.length === 2) return `${value}:00`;
    if (value.length === 3) return `${value.slice(0, 2)}:${value.slice(2)}0`;
    if (value.length === 4) return `${value.slice(0, 2)}:${value.slice(2)}`;
    return '00:00';
  }

  incrementTime(campo: string): void {
    const timeStr = this.horas[campo] || '00:00';
    const [hours, minutes] = timeStr.split(':').map(Number);
  
    let newMinutes = minutes + 5;
    let newHours = hours;
  
    if (newMinutes >= 60) {
      newMinutes = newMinutes % 60;
      newHours = (newHours + 1) % 24;
    }
  
    this.horas[campo] = `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
  }

  decrementTime(campo: string): void {
    const timeStr = this.horas[campo] || '00:00';
    const [hours, minutes] = timeStr.split(':').map(Number);
  
    let newMinutes = minutes - 5;
    let newHours = hours;
  
    if (newMinutes < 0) {
      newMinutes = 60 + newMinutes;
      newHours = (newHours - 1 + 24) % 24;
    }
  
    this.horas[campo] = `${newHours.toString().padStart(2, '0')}:${newMinutes.toString().padStart(2, '0')}`;
  }
}
